import { BaseBlock } from "./BaseBlock";

/**
 * Блок воспроизведения видео.
 */
export class VideoBlock extends BaseBlock {

    constructor(
        private readonly url: string
    ) {

        super();

    }

    public override mount(): void {

        this.root =
            document.createElement("div");

        this.root.className =
            "task video-task";

        const video =
            document.createElement("video");

        video.src = this.url;
        video.controls = true;

        this.root.appendChild(video);

    }

    public override update(): void {
    }

    public override unmount(): void {

        super.unmount();

    }

}